import { FC } from 'react'
import { DocumentsWelcome } from '@loadedhub/team-onboarding-management'
import TeamOnboardingWidgetProvider from '../../_common/components/TeamOnboardingWidgetProvider'

/** Help content for the Document Templates page - the onboarding welcome intro. */
const DocumentTemplatesHelpContent: FC = () => (
  <TeamOnboardingWidgetProvider>
    <DocumentsWelcome />
  </TeamOnboardingWidgetProvider>
)

export default DocumentTemplatesHelpContent
